const React = require('react');
const {object, string} = require("yup");

const {Link, replaceLocation} = require('../../../router');
const {LINK_TFA_RESET} = require("../../../constants/links");

const Base = require('../../smart/Page/AuthLayout');
const {MerchantInputsCode} = require("../../dumb/FormInputs");
const {FormWrapper, FormSubmitBtn} = require("../../dumb/FormHandlers");
const {cachedAccount$, onAccount} = require("../../../emitters/account");
const {apiAuthTfaVerify} = require("../../../api/_auth");

module.exports = () => {
  const schema = object({code: string().length(6).required()});
  const cachedAccount = cachedAccount$.getValue();

  if (!cachedAccount) {
    replaceLocation({
      path: '/',
    });
  }

  const onSubmit = (params) => (
    apiAuthTfaVerify(params)
        .then(onAccount)
  );

  return (
    <FormWrapper
      schema={schema}
      onSubmit={onSubmit}
      onResult={() => {
        replaceLocation({
          path: '/',
        });
      }}
    >
      {(formCtx) => (
        <Base
          cachedAccount={cachedAccount}
          title="Security verification"
          content={(
            <MerchantInputsCode
              label="Enter the 6 digit authentication code"
              name="code"
              formCtx={formCtx}
              codeLength={6}
            />
          )}
          control={(
            <FormSubmitBtn
              formCtx={formCtx}
            >
              Submit
            </FormSubmitBtn>
          )}
          additional={(
            <div className="f12 fw3 lh lts0em">
              <Link
                href={LINK_TFA_RESET}
                className="c5B47FF olN tdU dn f12 fw3 o70:h"
              >Lost access to verification?</Link>
            </div>
          )}
        />
      )}
    </FormWrapper>
  )
}
